import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '@insite-store360/services';
const TOKEN_HEADER_KEY = 'Authorization';

/** Anonymous training quiz uses these endpoints; attaching a stale JWT can cause 401 from the API gateway. */
function isPublicLiveQuizUrl(url: string): boolean {
  return url.includes('publicLiveQuiz');
}

/**
 * The public dealer self-registration endpoints, same reasoning as above: the
 * page is reached by link with no login, and a stale token left in this
 * browser's storage from an earlier session would be attached to an
 * unauthenticated call for no benefit and some risk.
 *
 * ⚠️ ANCHORED ON THE SERVICE ROOT, and it has to be. Two other routes end in
 * the same words and MUST keep their token:
 *
 *   ewarranty-service/configuration/dealer-registration   the Configuration tab
 *   ewarranty-service/dealer-registration/requests/…      the review queue
 *
 * An earlier version matched `/dealer-registration($|?)` anywhere in the URL,
 * which stripped the token off the Configuration tab's call — the tab answered
 * 401 and the error interceptor bounced the admin to the login screen.
 */
const PUBLIC_REGISTRATION_URL =
  /\/ewarranty-service\/dealer-registration(?:\/(?:settings|provinces|banks|zones|avatar|invoice|reference\/[^/?]+|status\/[^/?]+))?(?:\?|$)/;

function isPublicDealerRegistrationUrl(url: string): boolean {
  return PUBLIC_REGISTRATION_URL.test(url);
}

function isAzureBlobUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url, window.location.origin);
    return /\.blob\.core\.windows\.net$/i.test(hostname);
  } catch {
    return false;
  }
}

export const usersInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  let token = storageService.getToken();

  if (
    token != null &&
    !isPublicLiveQuizUrl(req.url) &&
    !isPublicDealerRegistrationUrl(req.url) &&
    !isAzureBlobUrl(req.url)
  ) {
    req = req.clone({
      headers: req.headers.set(TOKEN_HEADER_KEY, `Bearer ${token}`),
    });
  }

  return next(req);
};
